;
define("landing_page_my_account.tpl", function(){});

